module.exports = __webpack_public_path__ + "img/pen-hover.e133ce86.svg";